export let sortAscendingLabel = "q$Iz2c";
export let sortDescendingLabel = "ehwpte";
export let fromColumnLabel = "k$MCoc";
export let toColumnLabel = "PN6c3b";
export let subjectColumnLabel = "GRqhzd";
export let receivedColumnLabel = "JhTb7";
export let sentColumnLabel = "kQydGb";
export let returnTimeColumnLabel = "dD1RQd";
export let modifiedColumnLabel = "DuwSFd";
export let columnHeaderAriaLabel = "MZnM5d";
export let resizeButtonLabel = "AUgtpc";
export let categoryColumnLabel = "wFie$";
export let importanceColumnLabel = "iZjZcd";
export let priorityColumnLabel = "gE1GTe";
export let flagStatusColumnLabel = "Ou1eqb";
export let flagDueDateColumnLabel = "y4bFrd";
export let sizeColumnLabel = "RRLQye";
export default {sortAscendingLabel,sortDescendingLabel,fromColumnLabel,toColumnLabel,subjectColumnLabel,receivedColumnLabel,sentColumnLabel,returnTimeColumnLabel,modifiedColumnLabel,columnHeaderAriaLabel,resizeButtonLabel,categoryColumnLabel,importanceColumnLabel,priorityColumnLabel,flagStatusColumnLabel,flagDueDateColumnLabel,sizeColumnLabel};